import { render, staticRenderFns } from "./ResellerServiceViewGlobal.vue?vue&type=template&id=21583d14"
import script from "./ResellerServiceViewGlobal.vue?vue&type=script&lang=js"
export * from "./ResellerServiceViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports